import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=06ddefa3&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=06ddefa3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ddefa3')) {
      api.createRecord('06ddefa3', component.options)
    } else {
      api.reload('06ddefa3', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=06ddefa3&", function () {
      api.rerender('06ddefa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/tabelas/Paginate.vue"
export default component.exports